// One-click workload presets for the Deploy page. Picking a preset just
// fills the container-image field — everything is still fully editable
// afterwards, and "Custom" starts from a blank field for any other image.

export interface WorkloadPreset {
  key: string;
  label: string;
  containerImage: string;
  blurb: string;
}

export const WORKLOAD_PRESETS: WorkloadPreset[] = [
  {
    key: 'pytorch',
    label: 'PyTorch',
    containerImage: 'pytorch/pytorch:latest',
    blurb: 'Training & inference notebooks',
  },
  {
    key: 'stable-diffusion',
    label: 'Stable Diffusion',
    containerImage: 'ghcr.io/automatic1111/stable-diffusion-webui:latest',
    blurb: 'Text-to-image generation',
  },
  {
    key: 'ollama',
    label: 'Ollama / LLM',
    containerImage: 'ollama/ollama:latest',
    blurb: 'Serve local language models',
  },
  {
    key: 'custom',
    label: 'Custom',
    containerImage: '',
    blurb: 'Bring your own image',
  },
];
